// One preview match row, shared by every band and by the `#foundation`
// "3 · Preview" gallery card and `#s07` phone: a checkbox (ticked = kept,
// i.e. present in `accept_ids[]`), merchant + date, signed amount, and a
// `ConfidenceDot`. A struck row (bank-amended/removed since match, the
// design's "Adobe" row) renders unticked and line-through by default but is
// still togglable -- nothing is hidden, only unticked.
import { AmountText } from '@/components/AmountText';
import { ConfidenceDot } from '@/components/ConfidenceDot';
import { Checkbox } from '@moneyskyline/ui';
import type { AskMatchRow as AskMatchRowType } from '@/api/hooks/useAskPreview';

export function AskMatchRow({
  row,
  kept,
  onToggle,
}: {
  row: AskMatchRowType;
  kept: boolean;
  onToggle: (id: string) => void;
}) {
  return (
    <div
      className="flex items-center gap-2.5 border-b border-border/60 px-3 py-2 text-sm last:border-b-0"
      data-testid="ask-match-row"
      data-transaction-id={row.id}
    >
      <Checkbox checked={kept} onCheckedChange={() => onToggle(row.id)} aria-label={`Keep ${row.merchant}`} />
      <span className={['flex-1', row.struck ? 'text-muted-foreground line-through' : ''].join(' ')}>
        {row.merchant} <span className="text-muted-foreground">{row.posted_at}{row.pending ? ' · pending' : ''}</span>
      </span>
      <AmountText value={row.amount} currency={row.currency} className={row.struck ? 'text-muted-foreground' : ''} />
      <ConfidenceDot level={row.confidence} />
    </div>
  );
}

export default AskMatchRow;
